import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { useOpenXAgentContext } from '../../../context/useOpenXAgentContext.ts';
import { AGENT_TOOL_IDS } from '../agentsConfig.ts';
import type { OpenXAgentId, OpenXAgentSession } from '../types.ts';
import { OpenXAgentHistory } from './OpenXAgentHistory.tsx';
import { OpenXAgentSwitcher } from './OpenXAgentSwitcher.tsx';

type OpenXAgentMenuMainScreenProps = {
  sessions?: OpenXAgentSession[];
};

export const OpenXAgentMenuMainScreen = ({ sessions = [] }: OpenXAgentMenuMainScreenProps) => {
  const { setIsMenuOpen, setActiveToolId } = useOpenXAgentContext();

  const handleAgentSelect = (agentId: OpenXAgentId) => {
    setActiveToolId(AGENT_TOOL_IDS[agentId]);
    setIsMenuOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, pt: '10px', pb: 2, px: 1 }}>
      <OpenXAgentSwitcher onAgentSelect={handleAgentSelect} />
      <Divider sx={{ my: 1 }} />
      <OpenXAgentHistory sessions={sessions} />
    </Box>
  );
};
